import React, { ReactNode } from "react";

interface MaybeProps {
  condition: boolean;
  children: ReactNode;
}

export const Maybe: React.FC<MaybeProps> = ({ condition, children }) => {
  return <>{condition && children}</>;
};
